/* eslint-disable react/prop-types */
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CopyIcon from '@/assets/copy.svg';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useEffect, useState } from 'react';
import classes from './StoreDialog.module.css';

const StoreDialog = ({
  open,
  apiKey = 'HWE873827432492493223920',
  handleClose,
}) => {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    }
  }, [copied]);
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        '& .MuiPaper-root': {
          width: '620px',
        },
      }}
    >
      <DialogTitle>
        <div className={classes.title_wrapper}>
          API Key
          <CloseIcon onClick={handleClose} />
        </div>

      </DialogTitle>
      <DialogContent
        dividers
        sx={{ padding: '20px' }}
      >
        <div>
          Client key
        </div>
        <div className={classes.api_key}>
          {apiKey}
          <CopyToClipboard
            text={apiKey}
            onCopy={() => setCopied(true)}
          >
            <img src={CopyIcon} alt="" />
          </CopyToClipboard>
          {copied ? <span className={classes.copy_tip}>Copied.</span> : null}

        </div>
      </DialogContent>
      <DialogActions
        sx={{
          padding: '16px',
        }}
      >
        <Button
          onClick={handleClose}
          text="Cancel"
          variant="outlined"
          sx={{
            textTransform: 'none',
            height: '36PX',
            color: '#202223',
            backgroundColor: '#fff',
            borderColor: '#BABFC3',
            '&:hover': {
              backgroundColor: '#eff1f3',
              borderColor: '#BABFC3',
            },
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StoreDialog;
